<template lang="pug">
#dados-monitoramento
    .row
        .col-5
            item-informacoes(
                icon-class='flow flow-tractor',
                title='Área plantada identificada',
                :value='areaPlantadaIdentificada',
                unidade='ha',
                justify='flex-start'
            )
        .col-4
            item-informacoes(
                v-if='dadosPlantio.areasPlantadas',
                icon-class='element el-icon-time',
                title='Data da última visita',
                :value='dadosPlantio.ultimaVisita ? dadosPlantio.ultimaVisita.dataVisita : "-"',
                unidade='ha',
                justify='flex-start'
            )
        .col-3
            el-tag.status-colheita(
                v-if='areaMonitorada.statusColheita',
                size='small',
                effect='dark',
                :type='statusColheita.style'
            ) {{ statusColheita.nome }}

    h5(
        v-if='areaMonitorada.dadosMonitoramento && areaMonitorada.dadosMonitoramento.dadosCulturasIdentificadas.length > 0'
    ) Culturas identificadas
    .culturas-identificadas
        .cultura-identificada(
            v-for='(dadoCultura, index) in areaMonitorada.dadosMonitoramento.dadosCulturasIdentificadas'
        )
            .row
                .col-6.justify-content-between.d-flex.flex-column
                    item-informacoes(
                        :icon-class='iconeCultura(dadoCultura)',
                        title='Cultura',
                        :value='dadoCultura.culturaIdentificada ? dadoCultura.culturaIdentificada.nome : ""',
                        :small='true',
                        justify='flex-start'
                    )

                    item-informacoes(
                        icon-class='flow flow-tractor',
                        title='Área plantada',
                        :value='dadoCultura.areaCulturaIdentificadaHa',
                        unidade='ha',
                        :small='true',
                        justify='flex-start'
                    )

                    item-informacoes(
                        icon-class='flow flow-select-1',
                        title='Área colhida',
                        :value='dadoCultura.areaColhidaIdentificadaHa || " - "',
                        unidade='ha',
                        :small='true',
                        justify='flex-start'
                    )

                .col-6.d-flex.flex-column.justify-content-between
                    item-informacoes(
                        icon-class='mdi mdi-weight',
                        title='Produtividade estimada',
                        :value='dadoCultura.produtividade',
                        :unidade='dadoCultura.unidadeProdutividade',
                        :small='true',
                        justify='flex-start'
                    )

                    item-informacoes(
                        icon-class='flow flow-stack',
                        title='Volume contratado',
                        :value='getVolume(dadoCultura)',
                        :small='true',
                        justify='flex-start'
                    )

                    item-informacoes(
                        v-if='dadosPlantio.areasPlantadas',
                        icon-class='element small el-icon-date',
                        title='Data de plantio',
                        :value='dadosPlantio.areasPlantadas[index].dataEstimadaPlantio',
                        :small='true',
                        justify='flex-start'
                    )

                    small.visualizar-mapa.float-right(
                        @click='selectArea(dadoCultura)'
                    )
                        i.mdi.mdi-crosshairs-gps
                        span Visualizar no mapa
</template>

<script>
import { CULTURA_ICONS } from '@/utils/helpers/icon-mapper';
import ItemInformacoes from '../quantitativos/ItemInformacoes';
import MonitoramentoService from '@/services/MonitoramentoService';

import formatters from '@/utils/formatters';

const STATUS_COLHEITA = {
    COLHIDO: {
        nome: 'Colhido',
        style: 'success'
    },
    NAO_COLHIDO: {
        nome: 'Não colhido',
        style: 'info'
    },
    EM_COLHEITA: {
        nome: 'Em colheita',
        style: 'warning'
    }
};

export default {
    name: 'DadosMonitoramento',

    components: { ItemInformacoes },

    data() {
        return {
            dadosPlantio: {}
        };
    },

    props: {
        areaMonitorada: {
            type: Object,
            required: true
        },
        focusAreaPlantada: {
            type: Function,
            require: true
        }
    },

    methods: {
        iconeCultura(dadoCultura) {
            if (!dadoCultura.culturaIdentificada) return CULTURA_ICONS['null'];
            return CULTURA_ICONS[dadoCultura.culturaIdentificada.codigo];
        },
        getVolume(dadoCultura) {
            if (
                dadoCultura.areaCulturaIdentificadaHa &&
                dadoCultura.produtividade
            ) {
                const volume =
                    dadoCultura.areaCulturaIdentificadaHa *
                    dadoCultura.produtividade *
                    60;
                return formatters.formatNumber(volume) + ' kg';
            }
            return ' - ';
        },
        selectArea(dadoCultura) {
            this.focusAreaPlantada(dadoCultura);
        },
        getDadosPlantio() {
            MonitoramentoService.dadosPlantio(
                this.$route.params.idAreaMonitorada
            ).then(({ data }) => {
                this.dadosPlantio = data;
            });
        }
    },
    created() {
        this.getDadosPlantio();
    },

    computed: {
        areaPlantadaIdentificada() {
            return this.areaMonitorada.dadosMonitoramento.areaPlantadaHa;
        },
        statusColheita() {
            return STATUS_COLHEITA[this.areaMonitorada.statusColheita];
        }
    }
};
</script>

<style scoped lang="scss">
#dados-monitoramento {
    height: 400px;
    overflow-y: auto;
    overflow-x: hidden;

    padding: 10px;
    // border-top: 1px solid #DCDFE6;

    .title {
        margin-bottom: 10px;
        font-weight: map-get($font-weight, medium);
    }

    .culturas-identificadas {
        padding: 5px 0;
        .cultura-identificada {
            border-top: 1px solid #c3c3c3;
            padding: 5px 0;
            &:last-child {
                border-bottom: 1px solid #c3c3c3;
            }
            &:hover {
                background: #01a3a40a;
            }
            .visualizar-mapa {
                margin-right: 15px;
                padding: 15px 0;
                color: #a6ce39;
                cursor: pointer;
                i {
                    margin-right: 5px;
                }
            }
        }
    }
    .el-tag {
        margin-left: 8px;
    }
    .status-colheita {
        float: right;
        font-size: 0.95em;
        margin-right: 15px;
        margin-top: 15px;
    }
}
</style>
